import { defineMessages } from '../translate';

/** Split from `ui` so the always-loaded entry chunk carries only these strings. */
export default defineMessages('ui-route', {
  loadingLabel: 'Loading',
  updatingVersion: 'Updating to the latest version…',
  pageSnag: 'This page hit a snag',
  pageSnagBody: 'Something went wrong loading this view. You can try again — your work is safe.',
  reload: 'Reload',
} as const);
